import {
  CampaignCondition,
  CampaignRuleTarget,
  CampaignRuleTargetType,
} from "types/campaigns";
import { referralCustomerConditions } from "../../../campaignHelpers";
import { Condition } from "./ConditionReadOnly";

export const conditions = [
  {
    id: "not_contains",
    label: "doesNotContain",
  },
  {
    id: "contains",
    label: "contains",
  },
  {
    id: "is_not_one_of",
    label: "is_not_one_of",
  },
  {
    id: "is_one_of",
    label: "is_one_of",
  },
  {
    id: "contains_one_of",
    label: "containsOneOf",
  },
  {
    id: "not_contains_one_of",
    label: "notContainsOneOf",
  },
  {
    id: "is_one_of_group_values",
    label: "is_one_of_collections",
  },
  {
    id: "is_not_one_of_group_values",
    label: "is_not_one_of_collections",
  },
  {
    id: "has_at_least_one_label",
    label: "hasAtLeastOneCustomAttribute",
  },
  { id: "is_equal", label: "is_equal" },
  {
    id: "is_not_equal",
    label: "is_not_equal",
  },
  { id: "is_greater", label: "is_greater_than" },
  {
    id: "is_greater_or_equal",
    label: "is_greater_or_equal",
  },
  { id: "is_less", label: "is_less_than" },
  {
    id: "is_less_or_equal",
    label: "is_less_or_equal",
  },
  { id: "is_after", label: "is_after" },
  { id: "is_before", label: "is_before" },
  { id: "is_between", label: "is_between" },
  {
    id: "is_not_between",
    label: "is_not_between",
  },
  {
    id: "is_day_of_week",
    label: "is_day_of_week",
  },
  {
    id: "is_month_of_year",
    label: "is_month_of_year",
  },
  { id: "is_time_between", label: "is_time_between" },
  { id: "is_day_of_month", label: "is_day_of_month" },
  { id: "matches_regex", label: "matchesRegex" },
  { id: "starts_with", label: "startsWith" },
  { id: "ends_with", label: "endsWith" },
];

export const findConditionLabel = (conditionId: string) => {
  const condition = conditions.find(({ id }) => id === conditionId);

  return condition ? condition.label : "";
};

export const findConditionTypeLabel = (
  condition: Condition & { target?: CampaignRuleTarget },
  conditionTypes: CampaignCondition[],
) => {
  if (condition.attribute === "expression" && condition.target) {
    // Expression for referral campaigns have same attribute for referee and referral
    // we need to determine label by passed target property
    if (condition.target === CampaignRuleTargetType.SELF)
      return "refereeExpression";
    return "referrerExpression";
  }

  // Map new tiersIds attributes to their original labels
  if (condition.attribute === "customer.tiersIds") {
    const originalCondition = conditionTypes.find(
      (item) => item.attribute === "customer.tiers",
    );
    return originalCondition?.label || condition.attribute;
  }

  if (condition.attribute === "referrer.tiersIds") {
    const originalCondition = [
      ...conditionTypes,
      ...referralCustomerConditions,
    ].find((item) => item.attribute === "referrer.tiers");
    return originalCondition?.label || condition.attribute;
  }

  return (
    conditionTypes.find((item) => item.attribute === condition.attribute)
      ?.label || condition.attribute
  );
};

export const conditionsWithParams = [
  "transaction.sku.qty",
  "transaction.maker.qty",
  "transaction.category.qty",
  "transaction.sku.grossValue",
  "transaction.sku.grossValue",
  "transaction.maker.grossValue",
  "transaction.category.grossValue",
];

export const checkIsAttributeSuppressedHj = (attribute: string) => {
  const blackListedAttributes = [
    "customer.lastName",
    "customer.firstName",
    "customer.birthDate",
    "customer.phone",
    "customer.email",
    "customer.loyaltyCardNumber",
  ];

  return blackListedAttributes.includes(attribute);
};
